import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  DashboardHeader,
  DashboardKpiGrid,
  AttentionPanel,
  PerformanceCard,
  GroupsSection,
  type AttentionFocusTab,
} from "@/components/team-leader/dashboard";

export interface DashboardSearch {
  focus?: AttentionFocusTab;
}

export const Route = createFileRoute("/_authenticated/team-leader/dashboard")({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => ({
    focus:
      search.focus === "at-risk" || search.focus === "grading" || search.focus === "tickets"
        ? (search.focus as AttentionFocusTab)
        : undefined,
  }),
  component: TeamLeaderDashboard,
});

export function TeamLeaderDashboard() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  const focus: AttentionFocusTab = search.focus || "at-risk";

  const handleFocusChange = (nextFocus: AttentionFocusTab) => {
    navigate({
      to: "/team-leader/dashboard",
      search: (prev) => ({ ...prev, focus: nextFocus === "at-risk" ? undefined : nextFocus }),
      replace: true,
    });
  };

  return (
    <div className="space-y-6">
      <DashboardHeader />
      <DashboardKpiGrid />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <AttentionPanel focus={focus} onFocusChange={handleFocusChange} />
        <PerformanceCard />
      </div>
      <GroupsSection />
    </div>
  );
}
